// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  getInventory({ commit })
  {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
        NewApiService.get(
            "admin/inventory"
        )
        .then(({ data }) => {
            commit("setInventory", data);
          resolve(data);
        })
        .catch(({ response }) => {
            reject(response.data.errors);
        })
        .finally(() => {
          commit("setLoading", false);
        })
    })
  },
}